import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    skipValidation: Boolean,
  };

  connect() {
    this.element.addEventListener('change', () => {
      this.skipValidationValue = this.element.dataset.skipValidation;

      if (this.skipValidationValue) {
        this.element.form.querySelectorAll('[required]').forEach((field) => {
          field.removeAttribute('required');
        });
        this.element.form.classList.remove('needs-validation');
      }

      this.element.form.requestSubmit();
    });
  }
}
